import {
    NinchatActionType,
    NinchatUpdateUserAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
    NinchatActionPayload,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const updateUser = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatUpdateUserAction}`,
    async (arg: NinchatActionParams<NinchatUpdateUserAction> & NinchatActionPayload, {rejectWithValue}) => {
        const {
            payload,
            ...params
        } = arg

        params.action = NinchatActionType.NinchatUpdateUserAction

        try {
            return await ninchatClient.send(params, payload)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
